// 興味関心チェックAPI.
import axios, { AxiosInstance } from 'axios';
import { Dispatch } from 'redux';
import * as Moff from '../constants/MoffAPI';
import * as InterestCheck from '../constants/InterestCheck';
import * as AWS from '../constants/AWS';
import { getCurrentTime, convertInterestCheckUpdateDate } from '../utils/dateUtil';
import { ResponseData } from '../constants/InterestCheck';

export class InterestCheckAPI {
  /** インスタンス */
  private static _instance: InterestCheckAPI;
  private axiosInstance: AxiosInstance;

  /** インスタンスの取得 */
  public static get instance(): InterestCheckAPI | null {
    if (!this._instance) {
      this._instance = new InterestCheckAPI();
      
      // .envの設定 
      const API_BASE_URL = String(process.env.REACT_APP_INTEREST_CHECK_API_URL);
      const API_KEY = String(process.env.REACT_APP_INTEREST_CHECK_API_KEY);
      if (API_BASE_URL === 'undefined') {
        alert('.envにREACT_APP_INTEREST_CHECK_API_URLの設定がありません.');
        return null;
      }

      if (API_KEY === 'undefined') {
        alert('.envにREACT_APP_INTEREST_CHECK_API_KEYの設定がありません.');
        return null;
      }

      const userPool = AWS.userPool();
      const cognitoUser = userPool.getCurrentUser();
      if (cognitoUser === null) {
        return null;
      }

      const self = this;
      cognitoUser.getSession(function(err: any, session: any) {
        if (err) {
          return;
        }

        if (session) {
          self._instance.axiosInstance = axios.create({
            baseURL: API_BASE_URL,
            headers: {
              'Authorization': session.getIdToken().getJwtToken(),
              'x-api-key': API_KEY
            }
          });
        }
      });
    }

    // 生成済みのインスタンスを返す
    return this._instance;
  }

  /**
   *  件数取得.
   *
   * @param {string} uniqueId
   * @param {Function} requestFunc
   * @param {Function} fetchedFunc
   * @returns {*}
   * @memberof InterestCheckAPI
   */
  public getRecordCount(
    uniqueId: string, requestFunc: Function, fetchedFunc: Function): any {
    const self = this;
    const url = `/interests/users/${uniqueId}/records`;
    return (dispatch: Dispatch<any>) => {
      dispatch(requestFunc());
      this.axiosInstance.get(url)
        .then(function(response: any) {
          dispatch(fetchedFunc(Moff.SUCCESS, response.data));
        })
        .catch(function(error: any) {
          self.showAxiosError('getRecordCount', error);
          dispatch(fetchedFunc(Moff.ERROR, error));
        });
    };
  }

  /**
   * 指定の1件を取得.
   *
   * @param {string} uniqueId
   * @param {number} sequence
   * @param {Function} requestFunc
   * @param {Function} fetchedFunc
   * @returns {*}
   * @memberof InterestCheckAPI
   */
  public getRecord(
    uniqueId: string, sequence: number, requestFunc: Function, fetchedFunc: Function): any {
    const self = this;
    const url = `/interests/users/${uniqueId}/records/${sequence}`;
    return (dispatch: Dispatch<any>) => {
      dispatch(requestFunc());
      this.axiosInstance.get(url)
        .then(function(response: any) {
          dispatch(fetchedFunc(Moff.SUCCESS, response.data));
        })
        .catch(function(error: any) {
          self.showAxiosError('getRecord', error);
          dispatch(fetchedFunc(Moff.ERROR, error));
        });
    };
  }

  /**
   * 最後の日付を取得.
   * getRecordCount, getRecordと同じURLを呼ぶ.
   *
   * @param {string} userId
   * @param {string} uniqueId
   * @param {HTMLElement[]} elements
   * @param {Function} requestFunc
   * @param {Function} fetchedFunc
   * @returns {*}
   * @memberof InterestCheckAPI
   */
  public getLastDate(
    userId: string, uniqueId: string, elements: HTMLElement[],
    requestFunc: Function, fetchedFunc: Function): any {
    const self = this;

    // 件数取得.
    let getRecordCountURL = `/interests/users/${uniqueId}/records`;

    return (dispatch: Dispatch<any>) => {
      this.axiosInstance.get(getRecordCountURL)
        .then(function(recordCountResponse: any) {
          if (recordCountResponse.data.total === 0) {
            // elements[userId].innerText = 'ない';
            dispatch(fetchedFunc(InterestCheck.FINISH, recordCountResponse.data));
          } else {
            const sequence = recordCountResponse.data.total;
            // 指定されたシーケンスの情報から.
            const getRecordURL = `/interests/users/${uniqueId}/records/${sequence}`;
            self.axiosInstance.get(getRecordURL)
              .then(function(getRecordResponse: any) {
                // 最後の日付.
                let updateDate = convertInterestCheckUpdateDate((getRecordResponse.data as ResponseData).visited_day);
                // 今日 yyyy-mm-dd
                const today: string = getCurrentTime().day;

                // 年月日の隙間の記号は"/"ではなく"-".
                const isToday = (today === updateDate.replace(/\//g, '-'));
                if (isToday) {
                  updateDate = '本日';
                  // 色を変化させる.
                  elements[userId].className = 'kirokuToday';
                }

                elements[userId].innerText = updateDate;
                dispatch(fetchedFunc(InterestCheck.FINISH, recordCountResponse.data));
              })
              .catch(function(error: any) {
                elements[userId].innerText = '';
                dispatch(fetchedFunc(InterestCheck.FINISH, error));
              });
          }
        })
        .catch(function(error: any) {
          elements[userId].innerText = '';
          dispatch(fetchedFunc(InterestCheck.FINISH, error));
        });
    };
  }

  // エラーポップアップ.
  // apiNameはどのAPIによるものか.
  private showAxiosError(apiName: string, error: any) {
    if (error.toString().indexOf('Network Error') !== -1) {
      const errorMessage = '通信エラーが発生しました。インターネット接続が出来ることを確認してから再度ページを読み込み直して下さい。';
      alert(errorMessage);
    } else if (error.toString().indexOf('timeout') !== -1) {
      const errorMessage = '通信エラーが発生しました。インターネット接続が良好な環境で、再度ページを読み込み直して下さい。';
      alert(errorMessage);
    }

    // ログインへ.
    // window.location.href = '/';
  }
}


// WEBPACK FOOTER //
// ./src/api/InterestCheckAPI.tsx